<a routerLink="{{createUrl}}" *ngIf="canCreate"
  class="add-link bg-st-theme-primary rounded-circle shadow d-flex justify-content-center align-items-center" 
  [class.floater]="floater"
  >
  <span class="text-white"><sof-plus-icon size="2x"></sof-plus-icon></span>
</a>
